<template>
    <div class="a">
        <div v-if="ing">
            {{ times }}后重新获取
        </div>
        <div v-else @click="_do">点击获取验证码</div>
    </div>
</template>
<script>
export default {
    props: {
        phone: {
            default: ''
        },
        scene: {
            default: ''
        }
    },
    data() {
        return {
            timer: 0,
            times: 60,
            ing: false
        }
    },
    created() {
    },
    beforeDestroy() {
        clearTimeout(this.timer);
    },
    methods: {
        _do() {
            if (this.ing) {
                return;
            }
            if (!this.phone) {
                this._msg('手机号不能为空', 0);
                return;
            }
            this.$http.post('index/pcode', {
                phone: this.phone,
                scene: this.scene
            }).then(res => {
                if (res.code) {
                    this.ing = true;
                    let runTimer = () => {
                        //
                        this.times--;
                        if (this.times < 0) {
                            this.ing = false;
                            this.times = 60;
                            clearTimeout(this.timer);
                        }
                        clearTimeout(this.timer);
                        this.timer = setTimeout(runTimer, 1000);
                    };
                    runTimer();
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>